import { render, staticRenderFns } from "./leftLazyTree.vue?vue&type=template&id=36871723&scoped=true&"
import script from "./leftLazyTree.vue?vue&type=script&lang=js&"
export * from "./leftLazyTree.vue?vue&type=script&lang=js&"
import style0 from "./leftLazyTree.vue?vue&type=style&index=0&id=36871723&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36871723",
  null
  
)

export default component.exports